export const MERCHANDISE_ROUTE = 'merchandise'
export const PERSONS_CONTROL_ROUTE = 'persons-control'
export const SETTINGS_ROUTE = 'settings'
